import { render, staticRenderFns } from "./distributionShopRelationshipList.vue?vue&type=template&id=348c6635&scoped=true"
import script from "./distributionShopRelationshipList.vue?vue&type=script&lang=js"
export * from "./distributionShopRelationshipList.vue?vue&type=script&lang=js"
import style0 from "./distributionShopRelationshipList.vue?vue&type=style&index=0&id=348c6635&prod&lang=less&scoped=true"
import style1 from "./distributionShopRelationshipList.vue?vue&type=style&index=1&id=348c6635&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c6635",
  null
  
)

export default component.exports